import { trackEvent as trackLegacyEvent } from "../../../utils/mixpanel";
/**
 * Tracks a patient-channel analytics event through the shared Mixpanel and
 * Countly pipeline. Mixpanel is initialised once globally in `pages/_app.js`, so
 * this is a thin typed wrapper that funnels every `src/` CTA through a single
 * chokepoint. The legacy tracker already guards on-prem and not-logged-in cases.
 */
export function trackEvent(event, props) {
  trackLegacyEvent(event, props);
}